<template>
  <div v-if="message.type === 'automation_message'" class="flex m-2 md:max-w-xl md:ml-auto message text-sm">
    <AutomationMessage :message="message" :conversation="conversation" :fanpage="fanpage" :channel="channel" :customWidthStyle="customWidthStyle" :textIsLong="textIsLong" :hideStatus="hideStatus" />
  </div>
  <div v-else-if="message.type === 'resolve_message'" class="flex m-2 md:max-w-xl md:ml-auto message text-sm">
    <ResolveMessage :message="message" :channel="channel" :customWidthStyle="customWidthStyle" :hideStatus="hideStatus" />
  </div>
  <div v-else-if="message.type === 'internal_message'" class="flex m-2 md:max-w-xl md:ml-auto message text-sm">
    <InternalMessage v-on:image-width="handleImageWidthLimit" :message="message" :channel="channel" :customWidthStyle="customWidthStyle" :hideStatus="hideStatus" :textIsLong="textIsLong" />
  </div>
  <div v-else-if="message.type === 'agent_message'" class="flex m-2 md:max-w-xl md:ml-auto message text-sm">
    <AgentMessage v-on:image-width="handleImageWidthLimit" :message="message" :channel="channel" :customWidthStyle="customWidthStyle" :hideStatus="hideStatus" :textIsLong="textIsLong" />
  </div>
  <div v-else-if="message.type === 'wa_templated_message'" class="flex m-2 md:max-w-xl md:ml-auto message text-sm">
    <WhatsappTemplatedMessage :message="message" :channel="channel" :customWidthStyle="customWidthStyle" :hideStatus="hideStatus" :textIsLong="textIsLong" />
  </div>
  <div v-else-if="message.type === 'open_message'" class="flex m-2 md:max-w-xl md:ml-auto message text-sm">
    <ReopenMessage :message="message" :channel="channel" :customWidthStyle="customWidthStyle" :hideStatus="hideStatus" />
  </div>
  <div v-else class="flex m-2 md:max-w-xl message text-sm">
    <CustomerMessage v-on:image-width="handleImageWidthLimit" :customer="customer" :message="message" :channel="channel" :customWidthStyle="customWidthStyle" :hideStatus="hideStatus" :textIsLong="textIsLong" />
  </div>
</template>


<script>
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import AutomationMessage from '@/components/conversations/messages/AutomationMessage.vue'
import ResolveMessage from '@/components/conversations/messages/ResolveMessage.vue'
import ReopenMessage from '@/components/conversations/messages/ReopenMessage.vue'
import InternalMessage from '@/components/conversations/messages/InternalMessage.vue';
import AgentMessage from '@/components/conversations/messages/AgentMessage.vue';
import WhatsappTemplatedMessage from '@/components/conversations/messages/WhatsappTemplatedMessage.vue';
import CustomerMessage from '@/components/conversations/messages/CustomerMessage';

import { useFanpagesStore } from '@/stores/fanpages';
import { useCustomerChannelStore } from '@/stores/customerChannels';

dayjs.extend(relativeTime);

export default {
  name: 'MessageItem',
  components: {
    AutomationMessage,
    ResolveMessage,
    ReopenMessage,
    InternalMessage,
    AgentMessage,
    CustomerMessage,
    WhatsappTemplatedMessage,
  },
  props: ['message', 'customer', 'conversation'],
  setup() {
    let fanpagesStore = useFanpagesStore();
    let customerChannelStore = useCustomerChannelStore();
    return { fanpagesStore, customerChannelStore };
  },
  created: function () {
    this.markAsRead();
    setTimeout(() => {
      this.hideStatusFlag = true;
    }, 3000);
  },
  computed: {
    channel() {
      return this.customerChannelStore.getById(this.message.customer_channel_id);
    },
    fanpage() {
      let result;
      if (this.channel) {
        if (this.channel['type'] === 'messenger') {
          result = this.fanpagesStore.getByFanpageId(this.channel['identifier']);
        } else if (this.channel['type'] === 'instagram') {
          result = this.fanpagesStore.getByFanpageInstagramAccountId(this.channel['identifier']);
        }
        if (result) {
          return result;
        }
      }
      return '';
    },
    hideStatus() {
      return this.message.status === 'new' && this.timeDelta <= 2 && !this.hideStatusFlag;
    },
    timeDelta() {
      return dayjs().diff(this.message.created_at, 'second');
    },
    textIsLong() {
      return this.message.text.length > 55 || this.message.media_uri;
    },
    customWidthStyle() {
      if(this.imageForcedWidth) {
        return `max-width: ${this.imageForcedWidth}px`;
      }
      return '';
    },
    isPageHidden() {
      return this.$root.pageHidden;
    }
  },
  watch: {
    isPageHidden() {
      this.markAsRead();
    }
  },
  methods: {
    handleImageWidthLimit(width) {
      this.imageForcedWidth = width;
    },
    markAsRead() {
      if (this.message.status === 'new' && this.message.type === 'customer_message' && this.conversation.assigned_agent_id === this.$root.currentAgent.id) {
        if (!this.isPageHidden) {
          this.$root.messageEmit('agent_read_message', this.$root.token, this.message.id, this.conversation.id);
        }
      }
    }
  },
  data() {
    return {
      hideStatusFlag: false,
      imageForcedWidth: undefined,
    }
  },
}
</script>
